import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 0,
  class: "mb-20 fullWidth"
}
const _hoisted_4 = {
  key: 0,
  class: "dialog-footer mt-20"
}
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PurchaseAdvanceList = _resolveComponent("PurchaseAdvanceList")!
  const _component_MaterialList = _resolveComponent("MaterialList")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20",
      disabled: _ctx.formDisabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "申请原因",
            prop: "des",
            class: "fullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.des,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.des) = $event)),
                type: "textarea",
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.mode !== 'approval')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAddComand('material'))),
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" 添加物料 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: _ctx.handleRemoveComand }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" 移除 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table, {
            data: _ctx.ruleForm.details,
            border: "",
            fit: "",
            "row-key": "materialId",
            style: {"width":"100%"},
            "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
            "span-method": _ctx.objectSpanMethod,
            onSelectionChange: _ctx.handleTableSelect,
            "summary-method": _ctx.getSummaries,
            "show-summary": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55",
                fixed: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "数量",
                fixed: "",
                "min-width": "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.amount,
                    "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                    type: "number",
                    min: 0,
                    onInput: _ctx.handleCalcTotal
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "locationId",
                label: "仓库位置",
                fixed: "",
                "min-width": "160"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: row.locationId,
                    "onUpdate:modelValue": ($event: any) => ((row.locationId) = $event),
                    class: "filter-item",
                    placeholder: "输入关键字搜索",
                    size: _ctx.t('table.btnSize'),
                    onChange: ($event: any) => (_ctx.handleLocationChange($event, row))
                  }, {
                    default: _withCtx(() => [
                      (row.locationOption?.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.locationOption, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.locationId,
                              label: item.location?.location,
                              value: item.locationId
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_el_option, {
                            key: 1,
                            value: -1,
                            disabled: "",
                            style: {"color":"red"}
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode(" 需要采购 ", -1)
                            ]))]),
                            _: 1
                          }))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "size", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialAmount2",
                label: "库存数量",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialUsed",
                label: "已使用数量",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialNo",
                label: "物料编号",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialName",
                label: "物料名称",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialBrand",
                label: "物料品牌",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialModel",
                label: "物料型号",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialUnit",
                label: "物料单位",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialStandard",
                label: "封装规格"
              })
            ]),
            _: 1
          }, 8, ["data", "span-method", "onSelectionChange", "summary-method"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmitPre
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: _ctx.addType === 'purchaseAdvance' ? '预采购列表' : '物料列表',
          width: "80%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleAdd
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.addType === 'purchaseAdvance')
              ? (_openBlock(), _createBlock(_component_PurchaseAdvanceList, {
                  key: 0,
                  mode: "table",
                  ref: "PurchaseAdvanceList",
                  excludeIds: _ctx.getexcludeIds(),
                  statusIn: 0
                }, null, 8, ["excludeIds"]))
              : (_openBlock(), _createBlock(_component_MaterialList, {
                  key: 1,
                  ref: "MaterialList",
                  excludeIds: _ctx.getexcludeIds(),
                  officeSupplies: _ctx.type === 'OFFICE' ? true : false,
                  pathApi: "material"
                }, null, 8, ["excludeIds", "officeSupplies"]))
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true)
  ]))
}